// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OutOfStockModal_modal__ypQXe {
  width: 50rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin-block: 8rem;
}

.OutOfStockModal_modal-header__AHcWs > h2 {
  font-size: var(--text-lg);
  color: var(--primary-color);
  font-weight: 500;
}

.OutOfStockModal_modal-content__mboY9 {
  width: 25rem;
  text-align: center;
}

.OutOfStockModal_modal-content__img__WtDzj {
  max-height: 20rem;
  margin: 0 auto 2rem;
}

.OutOfStockModal_modal-content__name__BbwMg {
  font-size: var(--text-base);
  margin-bottom: 0.5rem;
}

.OutOfStockModal_modal-content__price__M2nA8 {
  font-weight: 700;
  color: var(--primary-color);
  justify-content: center;
}

.OutOfStockModal_modal-content__price-value__ubs9u {
  font-size: var(--text-lg);
}

.OutOfStockModal_modal-content__price-suffix__abTWp {
  font-size: var(--text-base);
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/OutOfStockModal/OutOfStockModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".modal {\n  width: 50rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n  margin-block: 8rem;\n}\n\n.modal-header > h2 {\n  font-size: var(--text-lg);\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.modal-content {\n  width: 25rem;\n  text-align: center;\n}\n\n.modal-content__img {\n  max-height: 20rem;\n  margin: 0 auto 2rem;\n}\n\n.modal-content__name {\n  font-size: var(--text-base);\n  margin-bottom: 0.5rem;\n}\n\n.modal-content__price {\n  font-weight: 700;\n  color: var(--primary-color);\n  justify-content: center;\n}\n\n.modal-content__price-value {\n  font-size: var(--text-lg);\n}\n\n.modal-content__price-suffix {\n  font-size: var(--text-base);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OutOfStockModal_modal__ypQXe`,
	"modal-header": `OutOfStockModal_modal-header__AHcWs`,
	"modal-content": `OutOfStockModal_modal-content__mboY9`,
	"modal-content__img": `OutOfStockModal_modal-content__img__WtDzj`,
	"modal-content__name": `OutOfStockModal_modal-content__name__BbwMg`,
	"modal-content__price": `OutOfStockModal_modal-content__price__M2nA8`,
	"modal-content__price-value": `OutOfStockModal_modal-content__price-value__ubs9u`,
	"modal-content__price-suffix": `OutOfStockModal_modal-content__price-suffix__abTWp`
};
export default ___CSS_LOADER_EXPORT___;
